import React, { useState } from "react";
import "../index.css";
import PostUserRule from "./PostUserRule";
import PutUserRule from "./PutUserRule";
// import { useNotifications } from "../hooks/useNotifications";
import buttonBackground from "../assets/button_background_blue.webp";

// Type definitions
export interface Notifications {
  mobile?: boolean;
  browser?: boolean;
  text?: boolean;
}

interface Rule {
  [key: string]: unknown;
}

interface WatcherFormNotificationsProps {
  formState: number;
  setFormState: (state: number) => void;
  sport: string;
  sportId: string | number;
  name: string;
  ruleType: number;
  teams: string[];
  books: string[];
  rule: Rule;
  notifications: Notifications;
  setNotifications: (notifications: Notifications) => void;
  isUpdate: boolean;
  ruleId?: number;
}

const WatcherFormNotifications: React.FC<WatcherFormNotificationsProps> = ({
  formState,
  setFormState,
  sport,
  sportId,
  name,
  ruleType,
  teams,
  books,
  rule,
  notifications,
  setNotifications,
  isUpdate,
  ruleId,
}) => {
  // const { isEnabled, requestPermission, permission } = useNotifications();
  const [mobileNotify, setMobileNotify] = useState<boolean>(
    notifications.mobile || false,
  );
  // const [browserNotify, setBrowserNotify] = useState<boolean>(
  //   notifications.browser || false,
  // );
  // const [showDeniedMessage, setShowDeniedMessage] = useState<boolean>(false);
  // const [showPermissionPrompt, setShowPermissionPrompt] =
  //   useState<boolean>(false);
  // const [showMobileMessage, setShowMobileMessage] = useState<boolean>(false);

  // Check if user is on mobile device
  // const isMobileDevice = (): boolean => {
  //   const userAgent = navigator.userAgent || navigator.vendor;
  //   return (
  //     /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
  //       userAgent.toLowerCase(),
  //     ) || window.innerWidth < 768
  //   );
  // };
  // const [textNotify, setTextNotify] = useState<boolean>(
  //   notifications.text || false
  // );

  const handlePrevious = (): void => {
    setFormState(formState - 1);
  };

  const handleChangeMobile = (): void => {
    const newValue = !mobileNotify;
    setMobileNotify(newValue);
    setNotifications({
      mobile: newValue,
      browser: false,
      //      text: textNotify,
    });
  };

  // const handleChangeBrowser = async (): Promise<void> => {
  //   const newValue = !browserNotify;

  //   // If enabling browser notifications
  //   if (newValue) {
  //     // Check if on mobile device first
  //     if (isMobileDevice()) {
  //       setShowMobileMessage(true);
  //       return;
  //     }

  //     // Check if permission is already denied
  //     if (permission === "denied") {
  //       // Don't enable, show help message immediately
  //       setBrowserNotify(false);
  //       setNotifications({
  //         mobile: mobileNotify,
  //         browser: false,
  //       });
  //       // setShowDeniedMessage(true);
  //       return;
  //     }

  //     // If not already enabled, show pre-prompt first
  //     if (!isEnabled) {
  //       setShowPermissionPrompt(true);
  //       return;
  //     } else {
  //       // Already enabled
  //       setBrowserNotify(true);
  //       setNotifications({
  //         mobile: mobileNotify,
  //         browser: true,
  //       });
  //       // setShowDeniedMessage(false);
  //     }
  //   } else {
  //     // Disabling
  //     setBrowserNotify(false);
  //     setNotifications({
  //       mobile: mobileNotify,
  //       browser: false,
  //     });
  //     // setShowDeniedMessage(false);
  //   }
  // };

  // const handlePermissionPromptConfirm = async (): Promise<void> => {
  //   setShowPermissionPrompt(false);
  //   const result = await requestPermission();
  //   // Only set to true if permission was granted
  //   if (result === "granted") {
  //     setBrowserNotify(true);
  //     setNotifications({
  //       mobile: mobileNotify,
  //       browser: true,
  //     });
  //     setShowDeniedMessage(false);
  //   } else if (result === "denied") {
  //     // Permission denied, show help message
  //     setBrowserNotify(false);
  //     setNotifications({
  //       mobile: mobileNotify,
  //       browser: false,
  //     });
  //     setShowDeniedMessage(true);
  //   } else {
  //     // Permission dismissed, don't enable
  //     setBrowserNotify(false);
  //     setNotifications({
  //       mobile: mobileNotify,
  //       browser: false,
  //     });
  //     setShowDeniedMessage(false);
  //   }
  // };

  // const handlePermissionPromptCancel = (): void => {
  //   setShowPermissionPrompt(false);
  // };

  // const handleChangeText = (): void => {
  //   const newValue = !textNotify;
  //   setTextNotify(newValue);
  //   setNotifications({
  //     mobile: mobileNotify,
  //     browser: browserNotify,
  //     text: newValue,
  //   });
  // };

  const currentNotifications: Notifications = {
    mobile: mobileNotify,
    browser: false,
    // text: textNotify,
  };

  return (
    <div style={{ marginTop: 10, padding: "0 10px" }}>
      <div
        className="center_me"
        style={{
          marginTop: 10,
        }}
      >
        <div
          className="row  center_me border_radius"
          style={{
            width: 350,
            // backgroundColor: "#181818",
            // borderRadius: 8,
          }}
        >
          <div className="center_me">
            <div
              className=" border_radius"
              style={{
                // backgroundColor: "#2a2a2a",
                // borderRadius: 8,
                marginTop: 10,
                marginBottom: 10,
                paddingLeft: 15,
                paddingRight: 15,
              }}
            >
              <h2
                className="font_family_base text_green"
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  marginBottom: 10,
                  textAlign: "center",
                  marginTop: 10,
                  //                  color: "#fff",
                }}
              >
                Notifications
              </h2>
            </div>
          </div>
          <button
            style={{
              marginBottom: 10,
              paddingTop: 5,
              paddingBottom: 5,
              width: 300,
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleChangeMobile}
          >
            <div
              className={
                mobileNotify
                  ? "background_3 has_border center_me border_radius"
                  : "background_1 center_me border_radius"
              }
              style={{
                padding: 12,
                alignItems: "center",
                justifyContent: "center",
                width: 300,
                marginTop: 10,
                margin: "0 auto",
              }}
            >
              <span
                className={" font_family_base"}
                style={{
                  fontSize: 16,
                  color: "#FFF",
                }}
              >
                Mobile Notifications: {mobileNotify ? "ON" : "OFF"}
              </span>
            </div>
          </button>
          {/* <button
            style={{
              marginBottom: 10,
              paddingTop: 5,
              paddingBottom: 5,
              width: 300,
              background: "none",
              border: "none",
              cursor: "pointer",
              display: "none",
            }}
            onClick={handleChangeBrowser}
          >
            <div
              className={
                browserNotify
                  ? "background_3 has_border center_me border_radius"
                  : "background_1 center_me border_radius"
              }
              style={{
                padding: 12,
                alignItems: "center",
                justifyContent: "center",
                width: 300,
                marginTop: 10,
                margin: "0 auto",
              }}
            >
              <span
                className="font_family_base"
                style={{
                  // color: browserNotify ? "#000" : "#4CAF50",
                  fontSize: 16,
                  color: "#FFF",
                }}
              >
                Browser Notifications
              </span>
            </div>
          </button> */}
          {/* {false && (showDeniedMessage || permission === "denied") && (
            <div
              className="background_2 border_radius"
              style={{
                margin: "10px 10px 0 10px",
                padding: 15,
              }}
            >
              <p
                className="font_family_base error_text_color"
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  marginBottom: 10,
                  textAlign: "center",
                  margin: 0,
                }}
              >
                Browser Notifications Blocked
              </p>
              <p
                className="font_family_base text_color_white"
                style={{
                  fontSize: 12,
                  textAlign: "center",
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                To enable notifications, update your browser settings:
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
              </div>
              <div
                className="font_family_base text_color_white"
                style={{
                  fontSize: 12,
                  textAlign: "left",
                  paddingLeft: 20,
                }}
              >
                <p style={{ margin: "5px 0" }}>
                  <strong>Chrome:</strong> Click the icon left of the URL (Look
                  for the lock or tune icon "sliders") → Site settings →
                  Notifications → Allow
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Edge:</strong> Click the (🔒) icon left of the URL →
                  Permissions for this site → Notifications → Allow
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Firefox:</strong> Click the (🔒) icon left of the URL
                  → Connection secure → More information → Permissions → Send
                  Notifications → Allow
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>Safari:</strong> Safari menu → Settings for This
                  Website → Notifications → Allow
                </p>
              </div>
            </div>
          )} */}
          {/* Mobile Device Message Modal */}
          {/* {false && showMobileMessage && (
            <div
              onClick={() => setShowMobileMessage(false)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="background_2 border_radius"
                style={{
                  padding: 30,
                  maxWidth: 400,
                  width: "90%",
                  textAlign: "center",
                  border: "1px solid #333",
                }}
              >
                <h3
                  className="font_family_base"
                  style={{
                    color: "#fff",
                    marginBottom: 15,
                    fontSize: 20,
                  }}
                >
                  Desktop Only Feature
                </h3>
                <p
                  className="font_family_base"
                  style={{
                    color: "#ccc",
                    marginBottom: 20,
                    fontSize: 16,
                    lineHeight: 1.5,
                  }}
                >
                  Browser notifications are only available on desktop devices.
                </p>
                <p
                  className="font_family_base"
                  style={{
                    color: "#888",
                    marginBottom: 25,
                    fontSize: 14,
                    lineHeight: 1.4,
                  }}
                >
                  You can enable this setting from your Profile page when using
                  a desktop browser.
                </p>
                <button
                  onClick={() => setShowMobileMessage(false)}
                  className="my-form-button-wide button-base button-3d font_family_base"
                  style={{
                    backgroundImage: `url(${buttonBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "white",
                    fontWeight: 700,
                    padding: "12px 24px",
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          )} */}
          {/* Permission Pre-Prompt Modal */}
          {/* {false && showPermissionPrompt && (
            <div
              onClick={handlePermissionPromptCancel}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="background_2 border_radius"
                style={{
                  padding: 30,
                  maxWidth: 400,
                  width: "90%",
                  textAlign: "center",
                  border: "1px solid #333",
                }}
              >
                <h3
                  className="font_family_base"
                  style={{
                    color: "#fff",
                    marginBottom: 15,
                    fontSize: 20,
                  }}
                >
                  Enable Browser Notifications
                </h3>
                <p
                  className="font_family_base"
                  style={{
                    color: "#ccc",
                    marginBottom: 20,
                    fontSize: 16,
                    lineHeight: 1.5,
                  }}
                >
                  Your browser will ask for permission to show notifications.
                  Please click <strong style={{ color: "#fff" }}>Allow</strong>{" "}
                  when prompted to receive alerts for your rules.
                </p>
                <p
                  className="font_family_base"
                  style={{
                    color: "#888",
                    marginBottom: 25,
                    fontSize: 13,
                    lineHeight: 1.4,
                  }}
                >
                  You can change this setting anytime in your browser's site
                  permissions.
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: 15,
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={handlePermissionPromptCancel}
                    className="my-form-button button-base button-3d font_family_base"
                    style={{
                      backgroundImage: `url(${buttonBackground})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      color: "white",
                      fontWeight: 700,
                      padding: "12px 24px",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handlePermissionPromptConfirm}
                    className="my-form-button button-base button-3d font_family_base"
                    style={{
                      backgroundImage: `url(${buttonBackground})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      color: "white",
                      fontWeight: 700,
                      padding: "12px 24px",
                    }}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          )} */}
          {/* <button
            style={{
              marginBottom: 10,
              paddingTop: 5,
              paddingBottom: 5,
              width: 300,
              background: "none",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleChangeText}
          >
            <div
              className={
                textNotify
                  ? "background_green center_me border_radius"
                  : "background_3 center_me border_radius"
              }
              style={{
                // backgroundColor: textNotify ? "#4CAF50" : "#3a3a3a",
                // borderRadius: 8,
                padding: 12,
                alignItems: "center",
                justifyContent: "center",
                width: 300,
                marginTop: 10,
                margin: "0 auto",
              }}
            >
              <span
                className="font_family_base"
                style={{
                  color: textNotify ? "#000" : "#4CAF50",
                  fontSize: 16,
                }}
              >
                Text Notifications
              </span>
            </div>
          </button> */}
          {/*  <div
            className=" border_radius"
            style={{
              margin: 10,
            }}
          >
            <p
              className="font_family_base text_color_white center_me"
              style={{
                color: "#fff",
                textAlign: "center",
                margin: 10,
              }}
            >
              If no notifications are selected, game alerts can still be viewed
              on the &quot;Active Games&quot; page.
            </p>
          </div> */}
        </div>
      </div>
      <div
        className="row"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginTop: 20,
          //          marginBottom: 30,
        }}
      >
        <div
          className="col_1of2 center_me"
          style={{
            flex: "1 1 50%",
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
          }}
        >
          <button
            className="my-form-button button-base button-3d font_family_base"
            style={{
              marginTop: "5px",
              marginBottom: "5px",
              backgroundImage: `url(${buttonBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              fontWeight: 700,
            }}
            onClick={handlePrevious}
          >
            ← Previous
          </button>
        </div>
        <div
          className="col_1of2 center_me"
          style={{
            flex: "1 1 50%",
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          {isUpdate ? (
            <PutUserRule
              ruleId={ruleId?.toString()}
              formState={formState}
              setFormState={setFormState}
              sport={sport}
              sportId={sportId}
              rule_type={ruleType}
              name={name}
              teams={teams}
              books={books}
              rule={rule}
              notifications={currentNotifications}
            />
          ) : (
            <PostUserRule
              formState={formState}
              setFormState={setFormState}
              sport={sport}
              sportId={sportId}
              name={name}
              rule_type={ruleType}
              teams={teams}
              books={books}
              rule={rule}
              notifications={currentNotifications}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default WatcherFormNotifications;
